"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedMessage = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var RecommendedMessage = function (_a) {
    var currentPaymentAmount = _a.currentPaymentAmount, recommendedPaymentAmount = _a.recommendedPaymentAmount;
    var Callout = (0, core_1.useComponents)().Callout;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement("div", { "data-testid": "recommended-message" }, currentPaymentAmount === recommendedPaymentAmount ? (react_1.default.createElement(Callout, { variant: "success" },
        react_1.default.createElement(Copy, { copyKey: "changeDirectDebitRecommendedIsEquals" }))) : currentPaymentAmount < recommendedPaymentAmount ? (react_1.default.createElement(Callout, { variant: "warning" },
        react_1.default.createElement(Copy, { copyKey: "changeDirectDebitRecommendedLessThan", values: {
                amount: (0, core_1.major0DP)((0, core_1.majorToMinor)(recommendedPaymentAmount)),
            } }))) : currentPaymentAmount > recommendedPaymentAmount ? (react_1.default.createElement(Callout, { variant: "success" },
        react_1.default.createElement(Copy, { copyKey: "changeDirectDebitRecommendedGreaterThan", values: {
                amount: (0, core_1.major0DP)((0, core_1.majorToMinor)(recommendedPaymentAmount)),
            } }))) : null));
};
exports.RecommendedMessage = RecommendedMessage;
